import * as yup from "yup";

// Construcción dinámica del esquema
const keys = Array.from({ length: 9 }, (_, i) => `ads_${i + 1}`);
const shape: any = {};

keys.forEach((key) => {
  shape[key] = yup.array().of(yup.string()).notRequired();
});

const staticAdsSchema = yup.object().shape(shape);

export {
    staticAdsSchema
}